import React from 'react';

import type { SxProps, Theme } from '@mui/material/styles';

import CustomTableRow from 'components/shared/CustomTable/CustomTableRow';
import CustomTableCellValue from 'components/shared/CustomTable/CustomTableCellValue';
import { styles } from 'components/shared/CustomTable/stylesTable';

import type { Column } from 'api/shared/models';

interface Props {
  row: any;
  index: number;
  columns: Column[];
}

const CustomRenderRow = ({ row, index, columns = [] }: Props) => {
  return (
    <CustomTableRow key={index}>
      {columns
        .filter((column) => column.status)
        .map((column, indexColumn) => {
          return (
            <CustomTableCellValue
              key={indexColumn}
              row={row}
              column={column}
              sx={
                [
                  styles.cellsCompact,
                  column.fixedColumn ? styles.fixedColumn : undefined,
                ] as SxProps<Theme>
              }
            />
          );
        })}
    </CustomTableRow>
  );
};

export default CustomRenderRow;
